import { useEffect, useRef } from 'react'
import { useFormikContext } from 'formik'

import { updateStateValue } from '../../../../utils/react'

/**
 * @template {*} TValue
 *
 * @param {string} name
 * @param {TValue} [defaultValue]
 *
 * @returns {[TValue, React.Dispatch<React.SetStateAction<TValue>>]}
 */
export function useFormikFieldValue(name, defaultValue) {
  const { setFieldValue, values } = useFormikContext()

  const value = values[name] === undefined ? defaultValue : values[name]
  const valueRef = useRef(value)

  useEffect(() => {
    valueRef.current = value
  }, [value])

  async function setValue(nextValueAction, shouldValidate) {
    const { current: currValue } = valueRef
    const nextValue = updateStateValue(nextValueAction, currValue)

    if (!Object.is(nextValue, currValue)) {
      await setFieldValue(name, nextValue, shouldValidate)
    }
  }

  return [value, setValue]
}
